import { reducers } from "@insite/client-framework/Store/Reducers";
import toolkitReducer, { ToolkitActions } from "@toolkit/Framework/Store/Toolkit/ToolkitReducer";

export type ToolkitAnyAction = ToolkitActions;
(reducers as any).toolkit = toolkitReducer;
